/* generated by pull.js */
const manifest = {
  "name": "Developer JS Console",
  "description": "開発者用のJavascriptコンソール。これが何か分からない場合は無視してください。",
  "tags": [
    "recommended"
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "enabledByDefault": false
};
import {mediaRecorderSupported} from "../../environment";
if (!mediaRecorderSupported) manifest.unsupported = true;
export default manifest;